import { render, staticRenderFns } from "./MarketBasicCommission.vue?vue&type=template&id=1f2f7e1a&scoped=true&"
import script from "./MarketBasicCommission.vue?vue&type=script&lang=js&"
export * from "./MarketBasicCommission.vue?vue&type=script&lang=js&"
import style0 from "./MarketBasicCommission.vue?vue&type=style&index=0&id=1f2f7e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f7e1a",
  null
  
)

export default component.exports